var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGgTitlebarSelectArrowDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 7.05,
    viewBox: "0 0 12 7.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "free-icon-right-arrow-271228_1_",
    "data-name": "free-icon-right-arrow-271228 (1)",
    transform: "translate(12 -101.478) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_991",
    "data-name": "\\uADF8\\uB8F9 991",
    transform: "translate(101.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3248",
    "data-name": "\\uD328\\uC2A4 3248",
    d: "M108.336,5.532,103,.192a.658.658,0,0,0-.928,0l-.393.393a.657.657,0,0,0,0,.928L106.159,6l-4.489,4.489a.658.658,0,0,0,0,.928l.393.393a.658.658,0,0,0,.928,0l5.345-5.345a.662.662,0,0,0,0-.932Z",
    transform: "translate(-101.478)",
    fill: "#a5a5a5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGgTitlebarSelectArrowDisabled);
export default __webpack_public_path__ + "static/media/gg_titlebar_select_arrow_disabled.915992f6a98b2b747e25ba0d771e4922.svg";
export { ForwardRef as ReactComponent };